<template>
  <div id="configure-barcodes">
    <div class="pa-5">
      <v-row>
        <v-col lg="8" cols="12">
          <v-form ref="addBarcodeForm">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">{{ $t("thead.name") }}</th>
                    <th class="text-left">{{ $t("thead.barcode") }}</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="card in barcodes" :key="card.name">
                    <td>{{ card.name }}</td>
                    <td>{{ card.barcode }}</td>
                    <td class="text-right">
                      <v-btn icon @click="openDeleteDialog(card)">
                        <v-icon color="red">mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <v-text-field
                        v-model="newBarcode.name"
                        :rules="rules.nameRules"
                        :disabled="loadingAdd"
                        :label="$t('label.name')"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        v-model="newBarcode.code"
                        :rules="rules.codeRules"
                        :disabled="loadingAdd"
                        :label="$t('label.barcode')"
                        :error-messages="inputBarcodeError"
                        @input="inputBarcodeError = ''"
                      ></v-text-field>
                    </td>
                    <td class="text-right">
                      <v-btn icon @click="addBarcode" :loading="loadingAdd">
                        <v-icon color="green">mdi-plus-circle </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-form>
        </v-col>
        <v-col class="text-center hidden-md-and-down" align-self="center">
          <v-icon size="150">mdi-barcode-scan</v-icon>
        </v-col>
      </v-row>
    </div>
    <v-dialog
      v-model="deleteDialogModel"
      max-width="600"
      persistent
      :fullscreen="this.$vuetify.breakpoint.xs"
      ><v-card class="pa-5">
        <v-row>
          <v-col>
            <div class="text-center display-2 font-weight-light">
              {{
                $t("message.delete_anonymous_card", {
                  barcode_name: deleteSelectedCard.name
                })
              }}
            </div>
          </v-col>
        </v-row>
        <v-row> </v-row>
        <v-row class="text-center">
          <v-col>
            <v-btn
              @click="deleteBarcode"
              :loading="loadingDelete"
              text
              class="red--text  no-text-transform font-weight-bold"
              >{{ $t("button.delete_barcode") }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              @click="deleteDialogModel = false"
              :disabled="loadingDelete"
              text
              class="grey--text  no-text-transform font-weight-bold"
              >{{ $t("button.cancel") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ConfigureBarcodes",
  data() {
    return {
      barcodes: this.$store.state.user.anonymous_cards,
      newBarcode: {
        name: "",
        code: ""
      },
      inputBarcodeError: "",
      deleteDialogModel: false,
      deleteSelectedCard: { name: "", code: "" },
      rules: {
        nameRules: [
          v => !!v || this.$t("rules.name_required"),
          v =>
            !this.barcodes.some(item => {
              return item.name === v;
            }) || this.$t("rules.name_is_used")
        ],
        codeRules: [
          v => !!v || this.$t("rules.code_required"),
          v =>
            !this.barcodes.some(item => {
              return item.barcode === v;
            }) || this.$t("rules.code_is_used")
        ]
      },
      loadingAdd: false,
      loadingDelete: false
    };
  },
  methods: {
    addBarcode() {
      this.inputBarcodeError = "";
      if (this.$refs.addBarcodeForm.validate()) {
        this.loadingAdd = true;
        this.$store
          .dispatch("user/addAnonymousCard", {
            name: this.newBarcode.name,
            barcode: this.newBarcode.code
          })
          .then(() => {
            this.$refs.addBarcodeForm.reset();
          })
          .catch(error => {
            if (
              error.response.status === 400 &&
              error.response.data.error_code === 47
            ) {
              this.inputBarcodeError = this.$t("rules.code_is_used");
            }
          })
          .finally(() => {
            this.loadingAdd = false;
          });
      }
    },
    openDeleteDialog(card) {
      this.deleteSelectedCard = card;
      this.deleteDialogModel = true;
    },
    deleteBarcode() {
      this.loadingDelete = true;
      this.$store
        .dispatch("user/deleteAnonymousCard", {
          name: this.deleteSelectedCard.name,
          barcode: this.deleteSelectedCard.barcode
        })
        .finally(() => {
          this.loadingDelete = false;
          this.deleteDialogModel = false;
        });
    }
  }
};
</script>

<style scoped></style>
